


















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { user, tickets } from '@/modules/shared/shared/store/namespaces';
import { IS_EMPLOYEE } from '@/modules/users/store/user.getters';
import { Statuses } from '@/modules/shared/shared/domain/constants/constants';

@Component
export default class PDTWorkFlow extends Vue {
    statuses = Statuses;

    @tickets.State('ticketDetail') ticketDetail;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
}
